import { render, staticRenderFns } from "./trendK3.vue?vue&type=template&id=c9b0cbe0"
import script from "./trendK3.vue?vue&type=script&lang=js"
export * from "./trendK3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports